import template from './periodListLink.html';
import controller from './periodListLink.controller';
import './periodListLink.scss';

let periodListLinkComponent = {
  restrict: 'E',
  bindings: {
    userInceptionId: '<',
    onClickPeriodMobileListLink: '&',
    dateToLoad: '<',
  },
  template,
  controller
};

export default periodListLinkComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacationsMobile/periodListLink/periodListLink.component.js